import { MLSListingService } from './../../../services/mls-listings.service';
import { userDetails } from './../../models/user.model';
import { Component, OnInit } from '@angular/core';
import { UserDetailService } from 'src/services/user-details.service';
@Component({
  selector: 'app-residential',
  templateUrl: './residential.component.html',
  styleUrls: ['./residential.component.css']
})
export class ResidentialComponent implements OnInit {
  userDetails : userDetails[];
  all_agents_id ='';
  listings: any=[];
  full_listing:any=[];
  residential="/residential";
  commercial="/commercial";
  constructor(private UserDetailService:UserDetailService, private mlsService:MLSListingService) { }
  
  ngOnInit(): void {
    this.UserDetailService.getEveryone().subscribe(res => {
      //console.log((res as any).Users);
      this.userDetails = (res as any).Users;
      this.userDetails.sort((a,b) => a.full_name < b.full_name ? -1 : a.full_name > b.full_name ? 1: 0);
      for(var i=0; i<this.userDetails.length; i++) {
        if(this.userDetails[i].agentMLS_ID) {
          this.all_agents_id = this.all_agents_id + '&agent=' + this.userDetails[i].agentMLS_ID;
        }
        
      }
      //console.log(this.all_agents_id);
      this.mlsService.getStrideListings(this.all_agents_id).subscribe(res => {
        //console.log(res);
        this.full_listing = res as any;
        this.listings=this.full_listing.filter((list:any)=>{
          return list.property.lotDescription !="Acreage,Few Trees,Tank/ Pond";//filtering out vv jones property from from residential listing temporarily
        });

      })

      

    });

  }

  getPrice(x:any) {
    var price = parseInt(x);
    var final_price = '$' + this.numberWithCommas(price);
    return final_price;
  }


  numberWithCommas(x:any) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getListingPageID(listing_id:any) {
    var link = '/listing/' + listing_id;
    return link;
  }

}
